module.exports = __webpack_public_path__ + "static/media/FrontImage.88d664ef.png";